module.exports = __webpack_public_path__ + "static/media/logo.633a71f0.svg";